// extracted by mini-css-extract-plugin
export var slice = "slices-module--slice--1r1AI";
export var beforeSectionSlice = "slices-module--before-section-slice--16qUa";
export var lastSlice = "slices-module--last-slice--2r6u2";
export var sectionSlice = "slices-module--section-slice--1ratA";